import type { TOC } from '@ember/component/template-only';
import {
  PrismAccordion,
  PrismBadge,
  PrismCheckbox,
  PrismIcon,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

import styles from './restrictions-panel.module.css';

interface RestrictionsPanelSignature {
  Args: {
    automationOn: boolean;
    effectiveMinLos: number | null;
    hasMinLosOverride: boolean;
    onToggleAutomation: (event: Event) => void;
  };
}

const RestrictionsPanel = <template>
  <PrismAccordion
    @initiallyOpened={{true}}
    @title={{t "general.hotel"}}
    class="mx-500 my-400"
    data-test-id="restrictions-panel"
  >
    <:summaryAfter>
      {{#if @hasMinLosOverride}}
        <PrismBadge @badgeType="info" @iconName="bullet" @iconPosition="left">
          {{t "pricing_manager.number_overrides" count=1}}
        </PrismBadge>
      {{/if}}
    </:summaryAfter>
    <:default>
      <div
        class="{{styles.automation-container}}
          mb-400 flex items-center justify-between p-400"
      >
        <PrismCheckbox
          @checked={{@automationOn}}
          @onChange={{@onToggleAutomation}}
          data-test-id="restrictions-automation-checkbox"
        >
          <p class={{if @automationOn styles.automation-label-on}}>
            {{t "pricing_manager.automation_on"}}
          </p>
        </PrismCheckbox>
        <div
          class="flex items-center gap-100
            {{unless @automationOn styles.automation-value-off}}"
        >
          <PrismIcon
            @color={{if @automationOn "on-intelligence" "disabled"}}
            @name={{if @automationOn "automation" "automation-off"}}
            @size="small"
          />
          <p
            class="text-300--regular"
            data-test-id="restrictions-panel-automation-value"
          >
            {{#if @effectiveMinLos}}
              {{t
                "pricing_assistant.stay_restrictions.min_los"
                count=@effectiveMinLos
              }}
            {{else}}
              {{t "pricing_manager.restrictions.no_restrictions"}}
            {{/if}}
          </p>
        </div>
      </div>
    </:default>
  </PrismAccordion>
</template> satisfies TOC<RestrictionsPanelSignature>;

export default RestrictionsPanel;
